import React, { useState } from "react";
import { server } from "../server";
import { toast } from "react-hot-toast";
import { BiRename } from "react-icons/bi";
import { FaHeadphonesAlt } from "react-icons/fa";
import { FaMapPin } from "react-icons/fa";
import { FaCalendarAlt } from "react-icons/fa";

const Hero = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    carType: "",
    days: "",
    pickUpDate: "",
    dropOffDate: "",
  });

  const [loading, setLoading] = useState(false);
  const [activeSlide, setActiveSlide] = useState(0);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const validateForm = () => {
    for (const key in formData) {
      if (!formData[key]) {
        toast.error(
          `${key.charAt(0).toUpperCase() + key.slice(1)} is required`
        );
        return false;
      }
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    const toastId = toast.loading("Booking...");

    try {
      const response = await fetch(`${server}/send-booking-email`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      toast.dismiss(toastId);

      if (response.ok) {
        toast.success("Reservation details sent! We will call you soon.", {
          duration: 10000,
        });
        setFormData({
          name: "",
          phone: "",
          carType: "",
          days: "",
          pickUpDate: "",
          dropOffDate: "",
        });
      } else {
        toast.dismiss(toastId);
        toast.error("Failed to send reservation details.");
      }
    } catch (error) {
      toast.dismiss(toastId);
      console.error("Error:", error);
      toast.error("An error occurred while sending your details.");
    } finally {
      toast.dismiss(toastId);
      setLoading(false);
    }
  };

  const slides = [
    {
      image: "img/carousel-2.jpg",
      title: "Enjoy 15% off your rental! Choose Your Model",
      text: "Explore Kenya with comfort and style.",
    },
    {
      image: "img/carousel-1.jpg",
      title: "Exclusive Savings on Your Next Rental: Book Now!",
      text: "Explore Kenya with comfort and style.",
    },
  ];

  return (
    <div className="header-carousel">
      <div
        id="carouselId"
        className="carousel slide"
        data-bs-ride="carousel"
        data-bs-interval="false"
      >
        <ol className="carousel-indicators">
          {slides.map((_, index) => (
            <li
              key={index}
              data-bs-target="#carouselId"
              data-bs-slide-to={index}
              className={activeSlide === index ? "active" : ""}
              onClick={() => setActiveSlide(index)}
              aria-current={activeSlide === index ? "true" : "false"}
              aria-label={`Slide ${index + 1}`}
            ></li>
          ))}
        </ol>
        <div className="carousel-inner" role="listbox">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`carousel-item ${
                activeSlide === index ? "active" : ""
              }`}
            >
              <img
                src={slide.image}
                className="img-fluid w-100"
                alt={`Slide ${index + 1}`}
              />
              <div className="carousel-caption">
                <div className="container py-4">
                  <div className="row g-5">
                    <div
                      className={`col-lg-6 ${
                        activeSlide === index ? "slide-in-left" : ""
                      }`}
                    >
                      <div className="bg-secondary rounded p-5">
                        <h4 className="text-white mb-4">
                          GET A CAR RESERVATION
                        </h4>
                        <form onSubmit={handleSubmit}>
                          <div className="row g-3">
                            {["name", "phone", "days"].map((field) => (
                              <div className="col-12" key={field}>
                                <div className="input-group">
                                  <div className="d-flex align-items-center bg-light text-body rounded-start p-2">
                                    {field === "name" ? (
                                      <BiRename />
                                    ) : field === "phone" ? (
                                      <FaHeadphonesAlt />
                                    ) : (
                                      <FaMapPin />
                                    )}

                                    <span className="ms-1">
                                      {field.charAt(0).toUpperCase() +
                                        field.slice(1)}
                                    </span>
                                  </div>
                                  <input
                                    className="form-control"
                                    type={field === "days" ? "text" : "text"}
                                    name={field}
                                    value={formData[field]}
                                    onChange={handleChange}
                                    placeholder={`Enter your ${
                                      field.charAt(0).toUpperCase() +
                                      field.slice(1)
                                    }`}
                                    aria-label={`Enter your ${
                                      field.charAt(0).toUpperCase() +
                                      field.slice(1)
                                    }`}
                                  />
                                </div>
                              </div>
                            ))}
                            <div className="col-12">
                              <select
                                className="form-select"
                                name="carType"
                                value={formData.carType}
                                onChange={handleChange}
                                aria-label="Select Car Type"
                              >
                                <option value="">Select Your Car Type</option>
                                {[
                                  "Nissan Note",
                                  "Toyota Filder",
                                  "Toyota Axio",
                                  "Toyota Alphard",
                                  "Toyota Voxy",
                                  "Toyota Noah",
                                  "Nissan X-Trail",
                                ].map((car) => (
                                  <option key={car} value={car}>
                                    {car}
                                  </option>
                                ))}
                              </select>
                            </div>
                            {["pickUpDate", "dropOffDate"].map((field) => (
                              <div className="col-12" key={field}>
                                <div className="input-group">
                                  <div className="d-flex align-items-center bg-light text-body rounded-start p-2">
                                    <FaCalendarAlt />
                                    <span className="ms-1">
                                      {field.charAt(0).toUpperCase() +
                                        field.slice(1).replace(/Date$/, "")}
                                    </span>
                                  </div>
                                  <input
                                    className="form-control"
                                    type="date"
                                    name={field}
                                    value={formData[field]}
                                    onChange={handleChange}
                                  />
                                </div>
                              </div>
                            ))}
                            <div className="col-12">
                              <button
                                className="btn btn-light w-100 py-2"
                                disabled={loading}
                              >
                                {loading ? "Booking..." : "Book Now"}
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div
                      className={`col-lg-6 ${
                        activeSlide === index ? "slide-in-right" : "d-none"
                      }`}
                    >
                      <div className="text-start">
                        <h1 className="display-5 text-white">{slide.title}</h1>
                        <p>{slide.text}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Hero;
